<div class="step-card">
  <form
    [formGroup]="activityForm"
    (ngSubmit)="onSubmitToLocalStorage()"
    class="step-form"
  >

    <!-- Ligne 1 : Superviseur + Mode d'exécution + Structure responsable -->
    <div class="form-section">
      <div class="form-row">
        <div class="field">
          <app-select
            label="Superviseur"
            formControlName="supervisor"
            [options]="structureData"
          />
          @if (activityForm.get('supervisor')?.touched && activityForm.get('supervisor')?.invalid) {
            <small class="field-error">Le superviseur est requis.</small>
          }
        </div>
        <div class="field">
          <app-select
            label="Mode d'exécution"
            formControlName="modeExecution"
            [options]="modeExecutions"
          />
        </div>
        <div class="field">
          <app-select
            label="Structure responsable"
            formControlName="structureResponsable"
            [options]="structureData"
          />
          @if (activityForm.get('structureResponsable')?.touched && activityForm.get('structureResponsable')?.invalid) {
            <small class="field-error">La structure responsable est requise.</small>
          }
        </div>
      </div>
    </div>

    <!-- Structures associées (FormArray dynamique) -->
    <div class="panel">
      <div class="panel-header">
        <h4 class="panel-title">Structures associées</h4>
        <!-- app-ui-button pour l'ajout (type="button" pour ne pas soumettre le form) -->
        <app-ui-button
          type="button"
          variant="secondary"
          size="sm"
          icon="add"
          iconPosition="left"
          label="Ajouter une structure"
          (clicked)="addStructureAssociee()"
        />
      </div>

      <div class="panel-body" formArrayName="structureAssociee">
        <div class="structures-list">
          @for (control of structureAssocieeFormArray.controls; track $index) {
            <div class="structures-row">
              <div class="structures-row__select">
                <app-select
                  [options]="structureData"
                  [formControlName]="$index"
                  placeholder="Sélectionner une structure"
                />
              </div>
              <button
                type="button"
                class="btn-danger-icon"
                [disabled]="structureAssocieeFormArray.length === 1"
                (click)="removeStructureAssociee($index)"
                aria-label="Supprimer cette structure"
              >
                <span class="material-icons">delete</span>
              </button>
            </div>
          }
        </div>
      </div>
    </div>

    <!-- Actions : Précédent + Suivant -->
    <div class="actions">
      <button type="button" class="btn btn-secondary btn-md" (click)="goBack()">
        <span class="material-icons btn-icon btn-icon--left">arrow_back</span>
        Précédent
      </button>
      <button type="submit" class="btn btn-primary btn-md">
        Suivant
        <span class="material-icons btn-icon btn-icon--right">arrow_right_alt</span>
      </button>
    </div>

  </form>
</div>